import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { fetchCategories } from 'entities/Category';
import { getSelectedPropertyCatalogId } from 'entities/Property/model/selectors/PropertySelectors';
import { getSearchCatalogItemIsActive } from 'features/SearchCatalogItems/model/selectors/searchCatalogItemsSelectors';
import { useAppDispatch } from 'shared/lib/hooks/useAppDispatch';
import {
    PropertyCatalog,
    PropertyCatalogItemsMoveTo,
} from 'widgets/PropertyCatalog';
import { SearchCatalogItems } from 'widgets/SearchCatalogItems';

export const CustomListAddItemsCatalog = () => {
    const dispatch = useAppDispatch();
    const isActive = useSelector(getSearchCatalogItemIsActive);
    const catalogId = useSelector(getSelectedPropertyCatalogId);

    useEffect(() => {
        if (catalogId) {
            dispatch(fetchCategories(catalogId));
        }
    }, [catalogId, dispatch]);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                minHeight: 0,
                height: '100%',
            }}
        >
            <Box
                sx={
                    isActive
                        ? {
                              display: 'flex',
                              flexDirection: 'column',
                              flex: 1,
                              minHeight: 0,
                          }
                        : undefined
                }
            >
                <SearchCatalogItems
                    catalogId={catalogId}
                    moveTo={PropertyCatalogItemsMoveTo.CUSTOM_LIST}
                    expandable
                    hideField
                />
            </Box>

            {!isActive ? (
                <Box
                    sx={{
                        display: 'flex',
                        borderRadius: '12px 12px 0 0',
                        overflow: 'hidden',
                        flex: 1,
                        minHeight: 0,
                    }}
                >
                    <PropertyCatalog
                        isEditing
                        moveTo={PropertyCatalogItemsMoveTo.CUSTOM_LIST}
                    />
                </Box>
            ) : null}
        </Box>
    );
};
